/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionableItemsVMResponseVM } from '../models/ActionableItemsVMResponseVM';
import type { CashFlowVMIEnumerableResponseVM } from '../models/CashFlowVMIEnumerableResponseVM';
import type { CashFlowVMResponseVM } from '../models/CashFlowVMResponseVM';
import type { DashboardVMResponseVM } from '../models/DashboardVMResponseVM';
import type { ExpenseByCategoryVMIEnumerableResponseVM } from '../models/ExpenseByCategoryVMIEnumerableResponseVM';
import type { ExpenseByCategoryVMResponseVM } from '../models/ExpenseByCategoryVMResponseVM';
import type { MetricTypesEnum } from '../models/MetricTypesEnum';
import type { PnlVMResponseVM } from '../models/PnlVMResponseVM';
import type { PropertyMetricTypesEnum } from '../models/PropertyMetricTypesEnum';
import type { PropertyMetricVMIEnumerableResponseVM } from '../models/PropertyMetricVMIEnumerableResponseVM';
import type { VacancyRateVMSeriesBMResponseVM } from '../models/VacancyRateVMSeriesBMResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AnalyticsService {
    /**
     * @param organizationId
     * @returns DashboardVMResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsDashboard(
        organizationId: number,
    ): CancelablePromise<DashboardVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{organizationId}/dashboard',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PnlVMResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsPnl(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PnlVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{organizationId}/pnl',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param organizationId
     * @param lastMonths
     * @returns VacancyRateVMSeriesBMResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsOrganizationVacancyrates(
        organizationId: number,
        lastMonths: number,
    ): CancelablePromise<VacancyRateVMSeriesBMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{organizationId}/organization-vacancyrates/{lastMonths}',
            path: {
                'organizationId': organizationId,
                'lastMonths': lastMonths,
            },
        });
    }
    /**
     * @param organizationId
     * @param metricType
     * @param propertyMetricType
     * @returns PropertyMetricVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalytics(
        organizationId: number,
        metricType: MetricTypesEnum,
        propertyMetricType: PropertyMetricTypesEnum,
    ): CancelablePromise<PropertyMetricVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{organizationId}/{metricType}/{propertyMetricType}',
            path: {
                'organizationId': organizationId,
                'metricType': metricType,
                'propertyMetricType': propertyMetricType,
            },
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CashFlowVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsOrganizationCashflow(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CashFlowVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{organizationId}/organization-cashflow',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param propertyId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CashFlowVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsPropertyCashflow(
        propertyId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CashFlowVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{propertyId}/property-cashflow',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param unitId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CashFlowVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsUnitCashflow(
        unitId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CashFlowVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{unitId}/unit-cashflow',
            path: {
                'unitId': unitId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CashFlowVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsTenantCashflow(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CashFlowVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{tenantId}/tenant-cashflow',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param userId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CashFlowVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsUserCashflow(
        userId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CashFlowVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{userId}/user-cashflow',
            path: {
                'userId': userId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param contractorId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CashFlowVMResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsContractorCashflow(
        contractorId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CashFlowVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{contractorId}/contractor-cashflow',
            path: {
                'contractorId': contractorId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ExpenseByCategoryVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsOrganizationExpensebycategory(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ExpenseByCategoryVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{organizationId}/organization-expensebycategory',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param propertyId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ExpenseByCategoryVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsPropertyExpensebycategory(
        propertyId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ExpenseByCategoryVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{propertyId}/property-expensebycategory',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param unitId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ExpenseByCategoryVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsUnitExpensebycategory(
        unitId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ExpenseByCategoryVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{unitId}/unit-expensebycategory',
            path: {
                'unitId': unitId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ExpenseByCategoryVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsTenantExpensebycategory(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ExpenseByCategoryVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{tenantId}/tenant-expensebycategory',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param userId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ExpenseByCategoryVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsUserExpensebycategory(
        userId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ExpenseByCategoryVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{userId}/user-expensebycategory',
            path: {
                'userId': userId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param contractorId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ExpenseByCategoryVMResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsContractorExpensebycategory(
        contractorId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ExpenseByCategoryVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{contractorId}/contractor-expensebycategory',
            path: {
                'contractorId': contractorId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param organizationId
     * @returns ActionableItemsVMResponseVM Success
     * @throws ApiError
     */
    public static getApiAnalyticsActionableitems(
        organizationId: number,
    ): CancelablePromise<ActionableItemsVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Analytics/{organizationId}/actionableitems',
            path: {
                'organizationId': organizationId,
            },
        });
    }
}
